import { useCallback } from 'react';
import { usePayment } from '../context/PaymentContext';

export const useExtracreditPayment = () => {
  const {
    amountToPayWithExtracredit,
    setAmountExtracredit,
    getMaxAmounts,
    loading,
    calculateRemainingPrice,
    setSelectedPaymentMethod,
  } = usePayment();

    // Validar e atualizar valor do Extracredit
  const handleAmountChange = useCallback((value, combinePayment, totalPrice) => {
    const maxAmounts = getMaxAmounts();
    let validValue = 0;
    if (combinePayment) {
      validValue = value && value > 0 ? Math.min(parseFloat(value), maxAmounts.maxExtracredit) : 0;
    } else {
      // Para pagamento único, usar o valor total como o valor para extracredit
      validValue = Math.min(totalPrice, maxAmounts.maxExtracredit);
    }


    setAmountExtracredit(validValue);
    if (!combinePayment) {
      if (validValue > 0) {
        setSelectedPaymentMethod("extracredit");
      } else {
        setSelectedPaymentMethod(null);
      }
    }
  }, [setAmountExtracredit, getMaxAmounts, setSelectedPaymentMethod]);

  // Validar se pode prosseguir com o Extracredit
  const canProceed = useCallback(() => {
    const remaining = calculateRemainingPrice();
    return amountToPayWithExtracredit > 0 ? remaining === 0 : true;
  }, [amountToPayWithExtracredit, calculateRemainingPrice]);

  // Limpar dados do Extracredit
  const clearExtracreditPayment = useCallback(() => {
    setAmountExtracredit(0);
  }, [setAmountExtracredit]);

  return {
    amountToPayWithExtracredit,
    maxAmount: getMaxAmounts().maxExtracredit,
    loading,
    handleAmountChange,
    canProceed,
    clearExtracreditPayment,
  };
};
